export default __webpack_public_path__ + "static/media/741.56e5333c.jpg";